const INSP = 'inspections'
const SCH_SET_INSP = 'inspection_setup_schemas'
const SCH_INSP = 'inspection_schemas'
const SCH_SORT = 'sorting_schemas'
const TREE_GEN = 'generic_trees'
const SCH_GEN = 'generic_schemas'
const SRC_GEN = 'generic_sources'
const SRC_INSP = 'inspection_sources'
const LANG = 'language_files'
const REP = 'reports'
const ELM = 'element_templates'
const USR = 'user_record'
const INSP_FIN = 'finished_inspections'
const QS = 'quick_selects'
const MARK = 'markers'
const REP_MARK = 'report_markers'
const MISC_IMG = 'misc_images'
const IMG_REF = 'image_reference'
const USR_INSP = 'users_inspections'
const REP_SCH = 'report_schemas'
const OP_HIST = 'operation_history'
const PROP = 'properties'
const CLI = 'client'
const OA_PROJ = 'oa_projects'
const OA_MARK = 'oa_markers'
const USR_REP = 'users_reports'
//For MISC_IMG table
const MISC = 'misc'
const SIG = 'signature'
const BRAND = 'brand'
const REP_COVER = 'report_cover'
const REP_EX = 'report_example'
const INSP_COVER = 'inspection_cover'
const REP_PRE = 'report_preamble'
const PROP_COVER = 'property_cover'

//For new Language Table
const LANG_V2 = 'language_v2'
const SUB = 'subcategories'
const CAT = 'categories'
const MAS = 'mastercategories'
const REC = 'recommendations'
const NAR = 'narratives'
const RAT = 'ratings'
const REP_SEC = 'report_sections'
//REL Tables for LANG_V2
const LANG_V2_MAS = `${LANG_V2}-${MAS}`
const LANG_V2_CAT = `${LANG_V2}-${CAT}`
const LANG_V2_SUB = `${LANG_V2}-${SUB}`
const LANG_V2_REC = `${LANG_V2}-${REC}`
const LANG_V2_NAR = `${LANG_V2}-${NAR}`
const LANG_V2_REP_SEC = `${LANG_V2}-${REP_SEC}`
const LANG_V2_RAT = `${LANG_V2}-${RAT}`
const LANG_RELS = [
  LANG_V2_MAS,
  LANG_V2_CAT,
  LANG_V2_SUB,
  LANG_V2_REC,
  LANG_V2_NAR,
  LANG_V2_REP_SEC,
  LANG_V2_RAT
]



const LANG_CATS = [
  SUB,
  CAT,
  MAS,
  REC,
  NAR,
  RAT,
  REP_SEC
]

const MISC_IMG_ENUM = [
  MISC,
  SIG,
  BRAND,
  REP_COVER,
  REP_EX,
  INSP_COVER,
  REP_PRE,
  PROP_COVER
]



//for new report test thing

const REP_V2 = 'reports_v2'
const REP_BLOCK = 'report_blocks'
const REP_NAR = 'report_narratives'
const REP_REC = 'report_recommendations'
const REP_IMG = 'report_images'
const PRE_IMG = 'preamble_images'
const ICN = 'report_icons'
const PRE_BLOCK = 'report_preamble_blocks'
const TOP_BLOCK = 'report_top_blocks'
const REP_V2_USR = `${REP_V2}-${USR}`
const CLI_V2 = 'clients_v2'
const REP_CHAT_THREAD = 'report_chat_threads'
const REP_TPL = 'report_templates'
const REP_TYPES = [REP_V2, REP_BLOCK, REP_IMG, PRE_IMG, REP_REC, REP_NAR, CLI_V2, PROP, TOP_BLOCK, PRE_BLOCK, REP_CHAT_THREAD, REP_TPL]
//property status enum data
const ARCH = 'Archived'
const ACTV = 'Active'
const NEW = 'New'
const PROP_STAT_ENUM = [ARCH, ACTV, NEW]

const ROLE = 'roles'
const USER = 'users'

const ALL = [
  SCH_SORT,
  SCH_GEN,
  LANG,
  REP,
  ELM,
  SRC_GEN,
  TREE_GEN,
  USR,
  QS,
  MARK,
  REP_MARK,
  REP_SCH,
  CLI,
  OA_PROJ,
  OA_MARK
]
const allMap = {
  SCH_SORT,
  TREE_GEN,
  SCH_GEN,
  SRC_GEN,
  LANG,
  REP,
  ELM,
  USR,
  QS,
  MARK,
  REP_MARK,
  MISC_IMG,
  REP_SCH,
  CLI,
  OA_PROJ,
  OA_MARK
}

module.exports = {
  INSP_FIN,
  SCH_SET_INSP,
  SCH_INSP,
  SCH_SORT,
  TREE_GEN,
  SCH_GEN,
  SRC_GEN,
  SRC_INSP,
  LANG,
  INSP,
  REP,
  ELM,
  USR,
  QS,
  MARK,
  MISC_IMG,
  REP_MARK,
  IMG_REF,
  OP_HIST,
  USR_INSP,
  USR_REP,
  ALL,
  allMap,
  MISC_IMG_ENUM,
  MISC,
  SIG,
  BRAND,
  REP_COVER,
  REP_EX,
  INSP_COVER,
  REP_PRE,
  REP_SCH,
  PROP,
  CLI,
  ARCH,
  ACTV,
  NEW,
  PROP_STAT_ENUM,
  PROP_COVER,
  OA_PROJ,
  OA_MARK,
  LANG_CATS,
  MAS,
  SUB,
  CAT,
  REC,
  NAR,
  RAT,
  REP_SEC,
  LANG_V2,
  LANG_RELS,
  LANG_V2_MAS,
  LANG_V2_CAT,
  LANG_V2_SUB,
  LANG_V2_REC,
  LANG_V2_NAR,
  REP_V2,
  REP_BLOCK,
  REP_NAR,
  REP_REC,
  REP_IMG,
  PRE_IMG,
  ICN,
  PRE_BLOCK,
  TOP_BLOCK,
  REP_CHAT_THREAD,
  REP_TYPES,
  LANG_V2_REP_SEC,
  LANG_V2_RAT,
  REP_V2_USR,
  CLI_V2,
  ROLE,
  USER,
  REP_TPL
}
